export const primary = {
  50: "#E2F0F3",
  100: "#C6E1E6",
  200: "#A8D1D9",
  300: "#8EC2CD",
  400: "#65ADBC",
  500: "#4B9AAA",
  600: "#377480",
  700: "#254D55",
  800: "#193339",
  900: "#0C1A1C",
};

export const secondary = {
  50: "#F1F8F6",
  100: "#C9E5DD",
  200: "#ACD8CA",
  300: "#91CBBA",
  400: "#67B7A0",
  500: "#4EA68D",
  600: "#418B76",
  700: "#29584B",
  800: "#1A372F",
  900: "#0C1C18",
};
